<app-toolbar [token]="token" [breadcrumbs]="breadcrumbs" [ProcedureValue]="ProcedureValue"></app-toolbar>
<div class="main-content">
  <div class="row">
    <div class="col xl8 l8 m12 s12">
      <video
        class="video-js vjs-big-play-centered pgg-video vjs-16-9"
        controls
        playsinline
        preload="auto" #idVideo>
        <p class="vjs-no-js">
          To view this video please enable JavaScript, and consider upgrading to a
          web browser that
          <a href="https://videojs.com/html5-video-support/" target="_blank">
            supports HTML5 video
          </a>
        </p>
      </video>
    </div>
    <div class="col xl4 l4 m12 s12" *ngIf="isTranscript==1">

      <div class="inptus-container">

        <div class="w-100">
          <div class="col s8">
            <mat-form-field class="w-100">
              <mat-label>Buscar</mat-label>
              <mat-icon matPrefix>search</mat-icon>
              <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="searchTermChange()" (keyup.enter)="searchWord()" [ngModelOptions]="{standalone: true}" >
            </mat-form-field>
          </div>
          <div class="col s2">
            <button mat-icon-button (click)="cleanInput()">
              <mat-icon>delete</mat-icon>
            </button>
          </div>
          <div class="col s2">
            <!-- <input type="text" [(ngModel)]="searchTerm" (ngModelChange)="searchTermChange()" (keyup.enter)="searchWord()" placeholder="Buscar palabra..."> -->
            <button mat-button mat-flat-button (click)="searchWord()"
                    class="background-color-buttom">
              <mat-icon>search</mat-icon>
            </button>
          </div>
        </div>

        <div  *ngIf="searchObject.list.length > 0 || isNotResult">

          <div class="search-selector-container" *ngIf="searchObject.list.length > 0">
            <button mat-icon-button (click)="changeIndexWord('DOWN')">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <p>
              {{updateSearch()}}
            </p>
            <button mat-icon-button (click)="changeIndexWord('UP')">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </div>
          <div class="search-selector-container" *ngIf="isNotResult">
            <p>Sin resultados</p>
          </div>

        </div>

      </div>


      <div class="transcript-container" #transcriptContainer>
        <div *ngFor="let speakerGroup of groupedTranscript">
          <div class="speaker-container">
            <p class="speaker-header">Speaker {{ speakerGroup[0].speaker }} ({{ formatTime(speakerGroup[0].start) }}):</p>
            <button
              *ngFor="let word of speakerGroup"
              class="transcript-button"
              [ngClass]="{
                'highlight': isHighlighted(word.start, currentTime),
                'highlightView': isHighlighted(word.start + 20, currentTime) || currentTime! < 11
              }"
              (click)="changeTime(word.start)"
            >
              {{ word.punctuated_word }}
            </button>
          </div>
        </div>
      </div>

    </div>
    <div class="col xl4 l4 m12 s12" *ngIf="isTranscript==2">
      Actualmente, no se encuentra disponible una transcripción para esta grabación.
    </div>
  </div>
</div>

<app-footer></app-footer>
